import TableStylesPlugin from "./utils";

export { TableStyleDefinition } from "./utils";
export { UI_DROPDOWN_TABLE_STYLES, COMMAND_TABLE_CLASSES } from "./menu";

export default TableStylesPlugin;
